export default "__VITE_ASSET__DVW9aFDR__"